import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { StackActions, useNavigation } from '@react-navigation/native';
import { memo, ReactNode, useCallback } from 'react';
import { TouchableOpacity } from 'react-native';

export const useNavBack = (): (() => void) => {
  const nav = useNavigation();

  return useCallback(() => {
    nav.dispatch(StackActions.pop(1));
  }, [nav]);
};

export const BackButton = memo(
  ({ size, children }: { size?: number; children?: ReactNode }) => {
    const navBack = useNavBack();
    const { rpx } = useResponsiveContext();
    size = size ?? rpx(28);

    return (
      <TouchableOpacity
        css={`
          align-items: center;
          justify-content: center;
          min-width: ${rpx(44)}px;
          min-height: ${rpx(44)}px;
          flex: 1;
        `}
        onPress={navBack}
      >
        {children ?? <Icon name="chevron-left" size={size} color="black" />}
      </TouchableOpacity>
    );
  },
);
